// Normalizes a URL by removing trailing slashes for consistent comparison
export const normalizeUrl = (url) => url?.replace(/\/$/, '') || '';